export const APP_FONT_SIZES = ["sm", "md", "lg"] as const;

export type AppFontSize = (typeof APP_FONT_SIZES)[number];

export const APP_FONT_SIZE_KEY = "appFontSize";

export const DEFAULT_APP_FONT_SIZE: AppFontSize = "md";

export const APP_FONT_SIZE_LABELS: Record<AppFontSize, string> = {
	sm: "Small",
	md: "Medium (default)",
	lg: "Large",
};

export const isAppFontSize = (value: string): value is AppFontSize => APP_FONT_SIZES.includes(value as AppFontSize);
